// @flow

import * as React from 'react';
import { css } from 'react-emotion';
import { elements } from '@peachjar/components';

const { Quote } = elements;

const styles = {
  rightColWrapper: css`
     {
      padding: 50px;
      max-width: 700px;
    }
  `,
};

type Props = {|
  +svg: React.Node,
  +quote?: {
    content?: string,
    author?: string,
    authorTitle?: string,
  },
|};

const WhiteSpaceSvgWrapper = ({ svg, quote }) => (
  <div className={styles.rightColWrapper}>
    <div className="layout-row layout-align-center-center">{svg}</div>
    <Quote {...quote} />
  </div>
);

export default WhiteSpaceSvgWrapper;



// WEBPACK FOOTER //
// ./src/Onboarding/components/WhiteSpaceSvgWrapper.jsx